import { createBrowserRouter } from 'react-router-dom';
import HomePage from './home';
import AuthPage from './auth';
import Protected from '../components/containers/protected';

const router = createBrowserRouter([

  { path: '/',           element: <Protected><HomePage /></Protected>},
  { path: '/auth',       element: <AuthPage />},

]);



export default router;